import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeSubTab: "",
};

const activeSubTabSlice = createSlice({
  name: "activeSubTab",
  initialState,
  reducers: {
    setActiveSubTabStore: (state, action) => {
      state.activeSubTab = action.payload;
    },
  },
});

export const { setActiveSubTabStore } = activeSubTabSlice.actions;
export default activeSubTabSlice.reducer;
